(function () {
  'use strict';

  angular
    .module('neo.home.configuracio')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.configuracio', {
        url: '/configuracio',
        templateUrl: 'home/configuracio/configuracio.tpl.html',
        controller: 'ConfiguracioCtrl',
        controllerAs: 'vm',
        resolve: {
          tarifes: function (Configuracio) {
            return Configuracio.get().$promise;
          },
          ajuntaments: function ($http, EnvironmentConfig) {
            return $http.get(EnvironmentConfig.API + 'public/towns').then(function (r) {
              return r.data
                .filter(function (t) { return t.name !== 'Altres'; })
                .sort(function (a, b) { return a.name.localeCompare(b.name, 'ca'); });
            });
          },
          distancies: function (Distancies) {
            return Distancies.query().$promise;
          }
        }
      });
  }
}());
